import React from 'react'
import FetchData from '../../shared/fetchData'
import Button from '../../components/UI/Button/Button'
import Modal from '../../components/UI/Modal/Modal'
import './AboutUs.css'
import TextareaAutosize from 'react-textarea-autosize'

        const AboutUs = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [text, setText] = React.useState('')
    const [editText, setEditText] = React.useState('')
    const [permission, setPermission] = React.useState(window.localStorage.getItem("permission"))

    const childRef = React.useRef()

    React.useEffect(() => {
        var raw = JSON.stringify({
            "version": "mtpx001"
        })
        var url = 'management/api/v1/contents/getCourierRule'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setLoading(false)
                    if (result.status == 0) {
                        setText(result.text)
                        setEditText(result.text)
                    }
                })
                .catch(error => setLoading(false))
    }, [])

    const updateContent = (event) => {
        var raw = JSON.stringify({
            "description": editText,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/contents/updateCourierRule'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setLoading(false)
                    if (result.status == 0) {
                        setText(editText)
                        childRef.current.closeModal()
                    }
                })
                .catch(error => setLoading(false))
    }
    const afterCloseModal = (event) => {
    }
    const edit = (event) => {
        childRef.current.openModal()
    }
    const changeText = (event) => {
        setEditText(event.target.value)
    }
    const modalContent = <div>
        <TextareaAutosize className="abt-us-text" onChange={changeText} value={editText} />
        <div className="row justify-content-center">
            <Button btnType="Success" clicked={updateContent} >ثبت</Button>
        </div>
    </div>

    return (
            <div className="row justify-content-center">
                {permission != null && permission.includes('CONTENT_READ') ?
                            <div className="row w-100 h-0" dir="ltr">
                                <div className="col-2">
                                    <Button btnType="Edit" clicked={edit} >ویرایش</Button>
                                </div>
                            </div>
                            : ''}
                <div className="about-us-cntnr">
                    {text}
                </div>
                <Modal
                    content={modalContent}
                    ref={childRef}
                    closePermission="true"
                    closeModal={(event) => afterCloseModal(event)}
                    />
            </div>
            )
}

export default AboutUs